module.exports = __webpack_public_path__ + "static/img/15040789601.63174ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15040789601.jpg
// module id = YZnf
// module chunks = 0